import * as React from "react";
import { SVGProps } from "react";

const SvgFourClubs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 288 403"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M276.5.4H11.8S.7.7.7 15.4v371.7c0 14.7 11.1 15 11.1 15h264.6s11.1-.3 11.1-15V15.4c.1-14.7-11-15-11-15Z"
      fill="#fff"
    />
    <mask
      id="four-clubs_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={217}
      width={288}
      height={186}
    >
      <path
        d="M169.9 217.2c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15V217.2H169.9Z"
        fill="url(#four-clubs_svg__a)"
      />
    </mask>
    <g mask="url(#four-clubs_svg__b)">
      <path
        d="M169.9 217.2c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15V217.2H169.9Z"
        fill="url(#four-clubs_svg__c)"
      />
    </g>
    <mask
      id="four-clubs_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={288}
      height={201}
    >
      <path
        d="M.7 200.8h72.4c69.6 0 139.2 0 208.7.1h5.7V15.4c0-14.7-11.1-15-11.1-15H11.8S.7.7.7 15.4v185.4Z"
        fill="url(#four-clubs_svg__d)"
      />
    </mask>
    <g mask="url(#four-clubs_svg__e)">
      <path
        d="M.7 200.8h72.4c69.6 0 139.2 0 208.7.1h5.7V15.4c0-14.7-11.1-15-11.1-15H11.8S.7.7.7 15.4v185.4Z"
        fill="url(#four-clubs_svg__f)"
      />
    </g>
    <mask
      id="four-clubs_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={283}
      height={403}
    >
      <path
        d="M1.3 387.1V16C1.3 1.3 12.4 1 12.4 1h265s2.4.1 5 1.6C279.5.5 276.6.4 276.6.4H11.8S.7.7.7 15.4v371.7c0 14.7 11.1 15 11.1 15h.6s-11.1-.3-11.1-15Z"
        fill="url(#four-clubs_svg__g)"
      />
    </mask>
    <g mask="url(#four-clubs_svg__h)">
      <path
        d="M1.3 387.1V16C1.3 1.3 12.4 1 12.4 1h265s2.4.1 5 1.6C279.5.5 276.6.4 276.6.4H11.8S.7.7.7 15.4v371.7c0 14.7 11.1 15 11.1 15h.6s-11.1-.3-11.1-15Z"
        fill="url(#four-clubs_svg__i)"
      />
      <mask
        id="four-clubs_svg__k"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={29}
        width={2}
        height={347}
      >
        <path
          d="M.7 29.5v346.3l.6-2.1v-338c-.2-2.1-.4-4.1-.6-6.2Z"
          fill="url(#four-clubs_svg__j)"
        />
      </mask>
      <g mask="url(#four-clubs_svg__k)">
        <path
          d="M.7 29.5v346.3l.6-2.1v-338c-.2-2.1-.4-4.1-.6-6.2Z"
          fill="url(#four-clubs_svg__l)"
        />
      </g>
    </g>
    <mask
      id="four-clubs_svg__n"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={283}
      height={402}
    >
      <path
        d="M286.9 15v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#four-clubs_svg__m)"
      />
    </mask>
    <g mask="url(#four-clubs_svg__n)">
      <path
        d="M286.9 15v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#four-clubs_svg__o)"
      />
    </g>
    <path
      d="M21.7 79.8c-.6 7.5-4.8 12.7-4.8 12.7h9.6s-4.2-5.2-4.8-12.7Z"
      fill="#000"
    />
    <path
      d="M28.7 71.4c-1 0-1.9.2-2.7.5l-.1-.1c1.7-1.3 2.8-3.3 2.8-5.6 0-3.9-3.1-7-7-7s-7 3.1-7 7c0 2.4 1.2 4.6 3.1 5.8-.9-.5-2-.7-3.1-.7-3.9 0-7 3.1-7 7s3.1 7 7 7c3.8 0 6.8-3 7-6.7.2 3.7 3.2 6.7 7 6.7 3.9 0 7-3.1 7-7 0-3.8-3.2-6.9-7-6.9ZM20.4 50.5c1-.3 1.7-.6 2.1-.9.4-.3.6-.8.7-1.4.1-.6.2-1.5.2-2.8v-4.2H9.3v-1.9l14.8-22.4h3.6v21.8h.5c1 0 1.7-.1 2.1-.2.4-.1.8-.4 1.1-.8.3-.4.5-1 .8-1.8h1.9l-.3 5.2h-6.1v4.2c0 1.1 0 2 .1 2.5s.2.9.4 1.2c.2.3.4.6.8.8.3.2.9.4 1.7.6v1.2H20.4v-1.1Zm-7-11.7h9.9v-6.3c0-1.6 0-3.4.1-5.3.1-2 .1-3.5.2-4.5h-.3l-9.9 15.8v.3ZM264.3 320.8c.6-7.5 4.8-12.7 4.8-12.7h-9.6c-.1 0 4.1 5.2 4.8 12.7Z"
      fill="#000"
    />
    <path
      d="M257.2 329.2c1 0 1.9-.2 2.7-.5l.1.1c-1.7 1.3-2.8 3.3-2.8 5.6 0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.4-1.2-4.6-3.1-5.8.9.5 2 .7 3.1.7 3.9 0 7-3.1 7-7s-3.1-7-7-7c-3.8 0-6.8 3-7 6.7-.2-3.7-3.2-6.7-7-6.7-3.9 0-7 3.1-7 7 0 3.8 3.2 6.9 7 6.9ZM265.5 350.1c-1 .3-1.8.6-2.1.9-.4.3-.6.8-.7 1.4-.1.6-.2 1.5-.2 2.8v4.2h14.1v1.9l-14.8 22.4h-3.6v-21.8h-.5c-1 0-1.7.1-2.1.2-.4.1-.8.4-1.1.8-.3.4-.5 1-.8 1.8h-1.9l.3-5.2h6.1v-4.2c0-1.1 0-2-.1-2.5s-.2-.9-.4-1.2c-.2-.3-.4-.6-.8-.8-.3-.2-.9-.4-1.7-.6V349h10.3v1.1Zm7 11.7h-9.9v6.3c0 1.6 0 3.4-.1 5.3-.1 2-.1 3.5-.2 4.5h.3l9.9-15.8v-.3ZM197 87.8c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M210.9 71.1c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM197 313.2c1.2-14.8 9.6-25.2 9.6-25.2h-19.2s8.4 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M183.1 330c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.3 13.9 13.9 13.9ZM91 87.8c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M104.9 71.1c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9S77.1 53.3 77.1 61c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9ZM91 313.2c1.2-14.8 9.6-25.2 9.6-25.2H81.4s8.4 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M77.1 330c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.3 13.9 13.9 13.9Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="four-clubs_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.739 -136.498) scale(580.824)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.739 -136.498) scale(580.824)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.485 371.1) scale(416.199)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.485 371.1) scale(416.199)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.093 117.334) scale(393.607)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.093 117.334) scale(393.607)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.21 0 0 -462.229 300.054 .254)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.21 0 0 -462.229 300.054 .254)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.693 -.18) scale(462.125)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-clubs_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.693 -.18) scale(462.125)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgFourClubs;
